import React, { useState } from 'react';
import { useCart } from '../context/CartContext';
import { logEvent } from '../analytics';

export default function Cart() {
  const {
    items,
    totalQty,
    isBulk,
    unitPrice,
    subtotal,
    shipping,
    total,
    unitsUntilBulk,
    isOpen,
    setIsOpen,
    updateQty,
    removeItem,
    BULK_THRESHOLD,
    BULK_UNIT_PRICE,
  } = useCart();

  const [loading, setLoading] = useState(false);

  async function handleCheckout() {
    if (items.length === 0) return;
    setLoading(true);
    logEvent('begin_checkout', { value: total, currency: 'ILS' });

    try {
      const res = await fetch('/.netlify/functions/create-checkout-session', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: items.map((i) => ({ id: i.id, name: i.name, qty: i.qty })),
          totalQty,
        }),
      });

      const data = await res.json();
      if (data.url) {
        window.location.href = data.url;
      } else {
        alert('שגיאה ביצירת הזמנה. אנא נסו שנית.');
      }
    } catch {
      alert('שגיאה בחיבור לשרת. אנא נסו שנית.');
    } finally {
      setLoading(false);
    }
  }

  if (!isOpen) return null;

  return (
    <div className="cart-overlay" onClick={() => setIsOpen(false)}>
      <div className="cart-panel" onClick={(e) => e.stopPropagation()}>
        <div className="cart-header">
          <h2 className="cart-title">סל הקניות שלך</h2>
          <button className="cart-close" onClick={() => setIsOpen(false)}>
            ✕
          </button>
        </div>

        {items.length === 0 ? (
          <p className="cart-empty">הסל ריק</p>
        ) : (
          <>
            <div className="cart-items">
              {items.map((item) => (
                <div key={item.id} className="cart-item">
                  <div className="cart-item-info">
                    <span className="cart-item-name">{item.nameHebrew}</span>
                    <span className="cart-item-price">₪{unitPrice} ליחידה</span>
                  </div>
                  <div className="cart-item-controls">
                    <button
                      className="qty-btn"
                      onClick={() => updateQty(item.id, item.qty - 1)}
                    >
                      −
                    </button>
                    <span className="qty-value">{item.qty}</span>
                    <button
                      className="qty-btn"
                      onClick={() => updateQty(item.id, item.qty + 1)}
                    >
                      +
                    </button>
                    <button
                      className="cart-item-remove"
                      onClick={() => removeItem(item.id)}
                    >
                      הסר
                    </button>
                  </div>
                </div>
              ))}
            </div>

            {unitsUntilBulk > 0 && (
              <div className="cart-upsell">
                הוסיפו עוד {unitsUntilBulk} {unitsUntilBulk === 1 ? 'יחידה' : 'יחידות'} וקבלו
                מחיר מוזל ({BULK_THRESHOLD} ב-₪{BULK_THRESHOLD * BULK_UNIT_PRICE}) ומשלוח חינם!
              </div>
            )}

            <div className="cart-summary">
              <div className="cart-row">
                <span>סה״כ ({totalQty} {totalQty === 1 ? 'יחידה' : 'יחידות'})</span>
                <span>₪{subtotal}</span>
              </div>
              <div className="cart-row">
                <span>משלוח</span>
                <span className={isBulk ? 'free-shipping' : ''}>
                  {isBulk ? 'חינם' : `₪${shipping}`}
                </span>
              </div>
              <div className="cart-row cart-total">
                <span>לתשלום</span>
                <span>₪{total}</span>
              </div>
            </div>

            <button
              className="btn btn-checkout"
              onClick={handleCheckout}
              disabled={loading}
            >
              {loading ? 'מעבד...' : 'עבור לתשלום'}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
